import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container mx-auto pt-8 pb-16 px-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-gray-100 text-3xl font-semibold pt-2" }, "Exports / ABRA Work", -1)
const _hoisted_3 = { class: "bg-white text-gray-700 p-4 mt-8 rounded-md shadow-md" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "mb-4 flex justify-between flex-col sm:flex-row" }
const _hoisted_7 = { class: "flex rounded-md mb-2 sm:mb-0 mr-0 sm:mr-2 md:mr-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-200 bg-gray-50 text-gray-500 text-sm" }, " Month ", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "flex justify-between items-stretch" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Lock", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Export", -1)
const _hoisted_13 = { class: "ml-1 text-right" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Sync with ABRA", -1)
const _hoisted_15 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_17 = { class: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-11/12 max-w-lg sm:mx-4" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Report exists ")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, " ABRA Work report records already exists for the selected month. Continue and overwrite the report in ABRA? ", -1)
const _hoisted_22 = { class: "flex items-center" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "Download ABRA records", -1)
const _hoisted_24 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_25 = { class: "bg-gray-50 px-4 py-3 sm:px-6 sm:flex flex-row-reverse" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "Continue", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "Close", -1)
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Sync finished ")
const _hoisted_31 = { class: "mb-4" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, "Skipped Galia Contracts", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, "Skipped ABRA Contracts", -1)
const _hoisted_34 = { class: "border overflow-hidden border-b border-gray-200 rounded-md" }
const _hoisted_35 = { class: "table-fixed min-w-full divide-y divide-gray-200" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r" }, "Contract"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-l" }, "Contract Type")
  ])
], -1)
const _hoisted_37 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_38 = { class: "px-2 py-3 whitespace-nowrap border-r" }
const _hoisted_39 = { class: "flex align-middle justify-between items-center" }
const _hoisted_40 = { class: "text-sm" }
const _hoisted_41 = { class: "px-2 py-1" }
const _hoisted_42 = { class: "mx-1" }
const _hoisted_43 = {
  title: "Hxsign",
  class: "mx-1 text-xs font-semibold text-center p-1 uppercase rounded-md text-indigo-600 bg-indigo-100"
}
const _hoisted_44 = { class: "px-2 py-3 whitespace-nowrap text-left text-sm font-medium border-l" }
const _hoisted_45 = { class: "px-2" }
const _hoisted_46 = { class: "border overflow-hidden border-b border-gray-200 rounded-md" }
const _hoisted_47 = { class: "table-fixed min-w-full divide-y divide-gray-200" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-500" }, "Person")
  ])
], -1)
const _hoisted_49 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_50 = { class: "px-2 py-3 whitespace-nowrap" }
const _hoisted_51 = { class: "flex align-middle justify-between items-center" }
const _hoisted_52 = { class: "text-sm" }
const _hoisted_53 = { class: "px-2 py-1" }
const _hoisted_54 = { class: "mx-1" }
const _hoisted_55 = {
  title: "ABRA Personal Number",
  class: "mx-1 text-xs font-semibold text-center p-1 uppercase rounded-md text-indigo-600 bg-indigo-100"
}
const _hoisted_56 = { class: "bg-gray-50 px-4 py-3 sm:px-6 sm:flex flex-row-reverse" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", null, "Continue", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", null, "Close", -1)
const _hoisted_59 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_61 = { class: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-11/12 max-w-lg sm:mx-4" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" Sync failed ")
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, " The sync could not be completed because some contracts are missing shift records for the selected month in ABRA. Please see the table below. ", -1)
const _hoisted_66 = { class: "flex items-center" }
const _hoisted_67 = { class: "w-full border overflow-hidden border-b border-gray-200 rounded-md" }
const _hoisted_68 = { class: "table-fixed min-w-full divide-y divide-gray-200" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-500" }, "Person")
  ])
], -1)
const _hoisted_70 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_71 = { class: "px-2 py-3 whitespace-nowrap" }
const _hoisted_72 = { class: "flex align-middle justify-between items-center" }
const _hoisted_73 = { class: "text-sm" }
const _hoisted_74 = { class: "px-2 py-1" }
const _hoisted_75 = { class: "mx-1" }
const _hoisted_76 = {
  title: "ABRA Personal Number",
  class: "mx-1 text-xs font-semibold text-center p-1 uppercase rounded-md text-indigo-600 bg-indigo-100"
}
const _hoisted_77 = { class: "bg-gray-50 px-4 py-3 sm:px-6 sm:flex flex-row-reverse" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("span", null, "Close", -1)
const _hoisted_79 = { key: 1 }
const _hoisted_80 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_81 = /*#__PURE__*/_createTextVNode(" Sync finished ")
const _hoisted_82 = { class: "mb-4" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, "Skipped Galia Contracts", -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, "Skipped ABRA Contracts", -1)
const _hoisted_85 = { class: "border overflow-hidden border-b border-gray-200 rounded-md" }
const _hoisted_86 = { class: "table-fixed min-w-full divide-y divide-gray-200" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r" }, "Contract"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-l" }, "Contract Type")
  ])
], -1)
const _hoisted_88 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_89 = { class: "px-2 py-3 whitespace-nowrap border-r" }
const _hoisted_90 = { class: "flex align-middle justify-between items-center" }
const _hoisted_91 = { class: "text-sm" }
const _hoisted_92 = { class: "px-2 py-1" }
const _hoisted_93 = { class: "mx-1" }
const _hoisted_94 = {
  title: "Hxsign",
  class: "mx-1 text-xs font-semibold text-center p-1 uppercase rounded-md text-indigo-600 bg-indigo-100"
}
const _hoisted_95 = { class: "px-2 py-3 whitespace-nowrap text-left text-sm font-medium border-l" }
const _hoisted_96 = { class: "px-2" }
const _hoisted_97 = { class: "border overflow-hidden border-b border-gray-200 rounded-md" }
const _hoisted_98 = { class: "table-fixed min-w-full divide-y divide-gray-200" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-500" }, "Person")
  ])
], -1)
const _hoisted_100 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_101 = { class: "px-2 py-3 whitespace-nowrap" }
const _hoisted_102 = { class: "flex align-middle justify-between items-center" }
const _hoisted_103 = { class: "text-sm" }
const _hoisted_104 = { class: "px-2 py-1" }
const _hoisted_105 = { class: "mx-1" }
const _hoisted_106 = {
  title: "ABRA Personal Number",
  class: "mx-1 text-xs font-semibold text-center p-1 uppercase rounded-md text-indigo-600 bg-indigo-100"
}
const _hoisted_107 = { class: "bg-gray-50 px-4 py-3 sm:px-6 sm:flex flex-row-reverse" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("span", null, "Continue", -1)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("span", null, "Close", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LockClosedIcon = _resolveComponent("LockClosedIcon")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_TruckIcon = _resolveComponent("TruckIcon")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_RefreshIcon = _resolveComponent("RefreshIcon")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_export_abra_work_table = _resolveComponent("export-abra-work-table")!
  const _component_system_lock_modal = _resolveComponent("system-lock-modal")!
  const _component_DialogOverlay = _resolveComponent("DialogOverlay")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_TabGroup = _resolveComponent("TabGroup")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Loading. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMonth) = $event)),
                  class: "form-select appearance-none block w-full md:w-auto text-sm font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-200 rounded-r-md"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (month) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: month.key,
                      value: month
                    }, _toDisplayString(month.name), 9, _hoisted_9))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.selectedMonth]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_app_button, {
                  onClick: _ctx.lockState,
                  type: "blue",
                  class: "mr-1 flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_LockClosedIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_app_button, {
                  onClick: _ctx.exportCsv,
                  type: "blue",
                  class: "ml-1 flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_TruckIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_Menu, {
                    as: "div",
                    class: "relative text-left"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_MenuButton, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_app_button, {
                            type: _ctx.syncInProgress ? 'blue-disabled' : 'blue',
                            class: "py-3"
                          }, {
                            default: _withCtx(() => [
                              (!_ctx.syncInProgress)
                                ? (_openBlock(), _createBlock(_component_ChevronDownIcon, {
                                    key: 0,
                                    class: "h-5 w-5 mr-2 -ml-1"
                                  }))
                                : (_openBlock(), _createBlock(_component_RefreshIcon, {
                                    key: 1,
                                    class: "h-5 w-5 mr-2 -ml-1 animate-spin"
                                  })),
                              _hoisted_14
                            ]),
                            _: 1
                          }, 8, ["type"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_Transition, {
                        "enter-active-class": "transition duration-100 ease-out",
                        "enter-from-class": "transform scale-95 opacity-0",
                        "enter-to-class": "transform scale-100 opacity-100",
                        "leave-active-class": "transition duration-75 ease-in",
                        "leave-from-class": "transform scale-100 opacity-100",
                        "leave-to-class": "transform scale-95 opacity-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_MenuItems, { class: "absolute right-0 mt-2 w-auto p-1 text-right origin-top-right divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_MenuItem, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("button", {
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.syncAbraWorkReport(false))),
                                    ref: "button",
                                    className: "w-48 px-4 py-2 rounded-md text-right text-sm font-medium leading-5 tracking-wide bg-white hover:bg-gray-50 text-gray-700"
                                  }, "Sync hours with ABRA", 512)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_MenuItem, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("button", {
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.syncAbraShifts(false))),
                                    ref: "button",
                                    className: "w-48 px-4 py-2 rounded-md text-right text-sm font-medium leading-5 tracking-wide bg-white hover:bg-gray-50 text-gray-700"
                                  }, "Sync shifts with ABRA", 512)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            (_openBlock(), _createBlock(_component_export_abra_work_table, {
              month: _ctx.selectedMonth,
              key: _ctx.selectedMonth
            }, null, 8, ["month"])),
            (_openBlock(), _createBlock(_component_system_lock_modal, {
              ref: "systemLockModal",
              systemLockReason: _ctx.SystemLockReason.AbraWorkReported,
              dateFrom: _ctx.formatDate(_ctx.dateFrom),
              dateTo: _ctx.formatDate(_ctx.dateTo),
              key: _ctx.selectedMonth
            }, null, 8, ["systemLockReason", "dateFrom", "dateTo"])),
            _createVNode(_component_TransitionRoot, {
              as: "template",
              show: _ctx.workReportSyncModalIsOpen
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Dialog, {
                  as: "div",
                  class: "fixed z-10 inset-0 overflow-y-auto",
                  onClose: _ctx.closeWorkReportSyncModal
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_TransitionChild, {
                        as: "template",
                        enter: "ease-out duration-300",
                        "enter-from": "opacity-0",
                        "enter-to": "opacity-100",
                        leave: "ease-in duration-200",
                        "leave-from": "opacity-100",
                        "leave-to": "opacity-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DialogOverlay, { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                        ]),
                        _: 1
                      }),
                      _hoisted_16,
                      _createVNode(_component_TransitionChild, {
                        as: "template",
                        enter: "ease-out duration-300",
                        "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                        "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_17, [
                            (_ctx.workReportSyncModalContent == 'existingRecords')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _createElementVNode("div", _hoisted_19, [
                                    _createVNode(_component_DialogTitle, {
                                      as: "h2",
                                      class: "text-3xl leading-6 font-semibold text-gray-800 mb-4 tracking-wide"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_20
                                      ]),
                                      _: 1
                                    }),
                                    _hoisted_21,
                                    _createElementVNode("div", _hoisted_22, [
                                      _createVNode(_component_app_button, {
                                        onClick: _ctx.fetchAbraWorkReport,
                                        type: _ctx.fetchInProgress ? 'green-disabled': 'green',
                                        class: _normalizeClass(['mb-2 sm:mb-0 w-full sm:w-auto'])
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_23
                                        ]),
                                        _: 1
                                      }, 8, ["onClick", "type"]),
                                      (_ctx.fetchInProgress)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Downloading ..."))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_25, [
                                    _createVNode(_component_app_button, {
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.syncAbraWorkReport(true))),
                                      type: _ctx.syncInProgress ? 'blue-disabled' : 'blue',
                                      class: _normalizeClass(['mb-2 sm:mb-0 w-full sm:w-auto'])
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_CheckIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                                        _hoisted_26
                                      ]),
                                      _: 1
                                    }, 8, ["type"]),
                                    _createVNode(_component_app_button, {
                                      onClick: _ctx.closeWorkReportSyncModal,
                                      type: "gray",
                                      class: _normalizeClass(['mr-2 w-full sm:w-auto'])
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_27
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ])
                                ]))
                              : (_ctx.workReportSyncModalContent == 'skippedContracts')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                    _createElementVNode("div", _hoisted_29, [
                                      _createVNode(_component_DialogTitle, {
                                        as: "h2",
                                        class: "text-3xl leading-6 font-semibold text-gray-800 mb-6 tracking-wide"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_30
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("div", _hoisted_31, [
                                        _createVNode(_component_TabGroup, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_TabList, { class: "mb-4 grid grid-cols-2 items-center overflow-hidden rounded-md text-sm text-center border border-indigo-100" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Tab, null, {
                                                  default: _withCtx(({ selected }) => [
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["group flex items-center justify-center p-2 hover:bg-indigo-100 hover:text-blue-700", {'bg-indigo-100 text-blue-700 font-semibold': selected, 'bg-white text-blue-600': !selected}])
                                                    }, [
                                                      _hoisted_32,
                                                      _createElementVNode("span", {
                                                        class: _normalizeClass(["ml-1 px-2 py-1 rounded-full bg-indigo-100 text-indigo-600 text-xs font-semibold group-hover:bg-indigo-200", {'bg-indigo-200': selected}])
                                                      }, _toDisplayString(_ctx.skippedGaliaContracts.length), 3)
                                                    ], 2)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_Tab, null, {
                                                  default: _withCtx(({ selected }) => [
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["group flex items-center justify-center p-2 hover:bg-indigo-100 hover:text-blue-700", {'bg-indigo-100 text-blue-700 font-semibold': selected, 'bg-white text-blue-600': !selected}])
                                                    }, [
                                                      _hoisted_33,
                                                      _createElementVNode("span", {
                                                        class: _normalizeClass(["ml-1 px-2 py-1 rounded-full bg-indigo-100 text-indigo-600 text-xs font-semibold group-hover:bg-indigo-200", {'bg-indigo-200': selected}])
                                                      }, _toDisplayString(_ctx.skippedAbraContracts.length), 3)
                                                    ], 2)
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_TabPanels, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_TabPanel, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_34, [
                                                      _createElementVNode("table", _hoisted_35, [
                                                        _hoisted_36,
                                                        _createElementVNode("tbody", _hoisted_37, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skippedGaliaContracts, (galiaContract) => {
                                                            return (_openBlock(), _createElementBlock("tr", {
                                                              key: galiaContract.id,
                                                              class: "hover:bg-gray-50"
                                                            }, [
                                                              _createElementVNode("td", _hoisted_38, [
                                                                _createElementVNode("div", _hoisted_39, [
                                                                  _createElementVNode("span", _hoisted_40, [
                                                                    _createElementVNode("span", _hoisted_41, _toDisplayString(galiaContract.person.surname) + " " + _toDisplayString(galiaContract.person.name), 1)
                                                                  ]),
                                                                  _createElementVNode("div", _hoisted_42, [
                                                                    _createElementVNode("span", _hoisted_43, _toDisplayString(galiaContract.person.hxsign), 1)
                                                                  ])
                                                                ])
                                                              ]),
                                                              _createElementVNode("td", _hoisted_44, [
                                                                _createElementVNode("span", _hoisted_45, _toDisplayString(galiaContract.contractType.name), 1)
                                                              ])
                                                            ]))
                                                          }), 128))
                                                        ])
                                                      ])
                                                    ])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_TabPanel, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_46, [
                                                      _createElementVNode("table", _hoisted_47, [
                                                        _hoisted_48,
                                                        _createElementVNode("tbody", _hoisted_49, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skippedAbraContracts, (abraContract) => {
                                                            return (_openBlock(), _createElementBlock("tr", {
                                                              key: abraContract.personalNumber,
                                                              class: "hover:bg-gray-50"
                                                            }, [
                                                              _createElementVNode("td", _hoisted_50, [
                                                                _createElementVNode("div", _hoisted_51, [
                                                                  _createElementVNode("span", _hoisted_52, [
                                                                    _createElementVNode("span", _hoisted_53, _toDisplayString(abraContract.name) + " " + _toDisplayString(abraContract.surname), 1)
                                                                  ]),
                                                                  _createElementVNode("div", _hoisted_54, [
                                                                    _createElementVNode("span", _hoisted_55, _toDisplayString(abraContract.personalNumber), 1)
                                                                  ])
                                                                ])
                                                              ])
                                                            ]))
                                                          }), 128))
                                                        ])
                                                      ])
                                                    ])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_56, [
                                      _createVNode(_component_app_button, {
                                        onClick: _cache[4] || (_cache[4] = () => {_ctx.closeWorkReportSyncModal(); _ctx.lockState()}),
                                        type: "blue",
                                        class: _normalizeClass(['mb-2 sm:mb-0 w-full sm:w-auto'])
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_CheckIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                                          _hoisted_57
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_app_button, {
                                        onClick: _ctx.closeWorkReportSyncModal,
                                        type: "gray",
                                        class: _normalizeClass(['mr-2 w-full sm:w-auto'])
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_58
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["onClose"])
              ]),
              _: 1
            }, 8, ["show"]),
            _createVNode(_component_TransitionRoot, {
              as: "template",
              show: _ctx.shiftsSyncModalIsOpen
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Dialog, {
                  as: "div",
                  class: "fixed z-10 inset-0 overflow-y-auto",
                  onClose: _ctx.closeShiftsSyncModal
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_59, [
                      _createVNode(_component_TransitionChild, {
                        as: "template",
                        enter: "ease-out duration-300",
                        "enter-from": "opacity-0",
                        "enter-to": "opacity-100",
                        leave: "ease-in duration-200",
                        "leave-from": "opacity-100",
                        "leave-to": "opacity-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DialogOverlay, { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                        ]),
                        _: 1
                      }),
                      _hoisted_60,
                      _createVNode(_component_TransitionChild, {
                        as: "template",
                        enter: "ease-out duration-300",
                        "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                        "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_61, [
                            (_ctx.shiftsSyncModalContent == 'missingShifts')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                  _createElementVNode("div", _hoisted_63, [
                                    _createVNode(_component_DialogTitle, {
                                      as: "h2",
                                      class: "text-3xl leading-6 font-semibold text-gray-800 mb-4 tracking-wide"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_64
                                      ]),
                                      _: 1
                                    }),
                                    _hoisted_65,
                                    _createElementVNode("div", _hoisted_66, [
                                      _createElementVNode("div", _hoisted_67, [
                                        _createElementVNode("table", _hoisted_68, [
                                          _hoisted_69,
                                          _createElementVNode("tbody", _hoisted_70, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.abracContractsWithoutShift, (abraContract) => {
                                              return (_openBlock(), _createElementBlock("tr", {
                                                key: abraContract.personalNumber,
                                                class: "hover:bg-gray-50"
                                              }, [
                                                _createElementVNode("td", _hoisted_71, [
                                                  _createElementVNode("div", _hoisted_72, [
                                                    _createElementVNode("span", _hoisted_73, [
                                                      _createElementVNode("span", _hoisted_74, _toDisplayString(abraContract.name) + " " + _toDisplayString(abraContract.surname), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_75, [
                                                      _createElementVNode("span", _hoisted_76, _toDisplayString(abraContract.personalNumber), 1)
                                                    ])
                                                  ])
                                                ])
                                              ]))
                                            }), 128))
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_77, [
                                    _createVNode(_component_app_button, {
                                      onClick: _ctx.closeShiftsSyncModal,
                                      type: "gray",
                                      class: _normalizeClass(['w-full sm:w-auto'])
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_78
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ])
                                ]))
                              : (_ctx.shiftsSyncModalContent == 'skippedContracts')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                    _createElementVNode("div", _hoisted_80, [
                                      _createVNode(_component_DialogTitle, {
                                        as: "h2",
                                        class: "text-3xl leading-6 font-semibold text-gray-800 mb-6 tracking-wide"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_81
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("div", _hoisted_82, [
                                        _createVNode(_component_TabGroup, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_TabList, { class: "mb-4 grid grid-cols-2 items-center overflow-hidden rounded-md text-sm text-center border border-indigo-100" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Tab, null, {
                                                  default: _withCtx(({ selected }) => [
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["group flex items-center justify-center p-2 hover:bg-indigo-100 hover:text-blue-700", {'bg-indigo-100 text-blue-700 font-semibold': selected, 'bg-white text-blue-600': !selected}])
                                                    }, [
                                                      _hoisted_83,
                                                      _createElementVNode("span", {
                                                        class: _normalizeClass(["ml-1 px-2 py-1 rounded-full bg-indigo-100 text-indigo-600 text-xs font-semibold group-hover:bg-indigo-200", {'bg-indigo-200': selected}])
                                                      }, _toDisplayString(_ctx.skippedGaliaContracts.length), 3)
                                                    ], 2)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_Tab, null, {
                                                  default: _withCtx(({ selected }) => [
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["group flex items-center justify-center p-2 hover:bg-indigo-100 hover:text-blue-700", {'bg-indigo-100 text-blue-700 font-semibold': selected, 'bg-white text-blue-600': !selected}])
                                                    }, [
                                                      _hoisted_84,
                                                      _createElementVNode("span", {
                                                        class: _normalizeClass(["ml-1 px-2 py-1 rounded-full bg-indigo-100 text-indigo-600 text-xs font-semibold group-hover:bg-indigo-200", {'bg-indigo-200': selected}])
                                                      }, _toDisplayString(_ctx.skippedAbraContracts.length), 3)
                                                    ], 2)
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_TabPanels, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_TabPanel, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_85, [
                                                      _createElementVNode("table", _hoisted_86, [
                                                        _hoisted_87,
                                                        _createElementVNode("tbody", _hoisted_88, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skippedGaliaContracts, (galiaContract) => {
                                                            return (_openBlock(), _createElementBlock("tr", {
                                                              key: galiaContract.id,
                                                              class: "hover:bg-gray-50"
                                                            }, [
                                                              _createElementVNode("td", _hoisted_89, [
                                                                _createElementVNode("div", _hoisted_90, [
                                                                  _createElementVNode("span", _hoisted_91, [
                                                                    _createElementVNode("span", _hoisted_92, _toDisplayString(galiaContract.person.surname) + " " + _toDisplayString(galiaContract.person.name), 1)
                                                                  ]),
                                                                  _createElementVNode("div", _hoisted_93, [
                                                                    _createElementVNode("span", _hoisted_94, _toDisplayString(galiaContract.person.hxsign), 1)
                                                                  ])
                                                                ])
                                                              ]),
                                                              _createElementVNode("td", _hoisted_95, [
                                                                _createElementVNode("span", _hoisted_96, _toDisplayString(galiaContract.contractType.name), 1)
                                                              ])
                                                            ]))
                                                          }), 128))
                                                        ])
                                                      ])
                                                    ])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_TabPanel, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_97, [
                                                      _createElementVNode("table", _hoisted_98, [
                                                        _hoisted_99,
                                                        _createElementVNode("tbody", _hoisted_100, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skippedAbraContracts, (abraContract) => {
                                                            return (_openBlock(), _createElementBlock("tr", {
                                                              key: abraContract.personalNumber,
                                                              class: "hover:bg-gray-50"
                                                            }, [
                                                              _createElementVNode("td", _hoisted_101, [
                                                                _createElementVNode("div", _hoisted_102, [
                                                                  _createElementVNode("span", _hoisted_103, [
                                                                    _createElementVNode("span", _hoisted_104, _toDisplayString(abraContract.name) + " " + _toDisplayString(abraContract.surname), 1)
                                                                  ]),
                                                                  _createElementVNode("div", _hoisted_105, [
                                                                    _createElementVNode("span", _hoisted_106, _toDisplayString(abraContract.personalNumber), 1)
                                                                  ])
                                                                ])
                                                              ])
                                                            ]))
                                                          }), 128))
                                                        ])
                                                      ])
                                                    ])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_107, [
                                      _createVNode(_component_app_button, {
                                        onClick: _cache[5] || (_cache[5] = () => {_ctx.closeShiftsSyncModal(); _ctx.lockState()}),
                                        type: "blue",
                                        class: _normalizeClass(['mb-2 sm:mb-0 w-full sm:w-auto'])
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_CheckIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                                          _hoisted_108
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_app_button, {
                                        onClick: _ctx.closeShiftsSyncModal,
                                        type: "gray",
                                        class: _normalizeClass(['mr-2 w-full sm:w-auto'])
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_109
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["onClose"])
              ]),
              _: 1
            }, 8, ["show"])
          ]))
    ])
  ]))
}